module.exports = __webpack_public_path__ + "img/vertical_6_5_9005.71c2c45c.png";